'use client';

import { useExamViewCount } from '../hooks/use-exam-view-count';

export default function ExamViewCountTracker() {
  useExamViewCount();
  return null;
}
